import getStore from '../store/publishingStore';
import { setInitialPublishPermissionsPending } from '../actions/calendarPublishing';
import { mutator } from 'satcheljs';

export default mutator(setInitialPublishPermissionsPending, msg => {
    let viewState = getStore().viewState;
    viewState.isInitialLoadPending = msg.isPending;
});
